<div class="rightSection ip-section">
    <div class="page-content">
        <h2 class="heading7">{{'Language.JournalEntryText' | translate}}</h2>
        <!-- ============ Journal Entry Detail ============ -->
        <!-- <mat-card class="my-4">
            <mat-card-content> -->
        <mat-tab-group mat-stretch-tabs="false" class="opportunitytabs" [selectedIndex]="this.selectedTabIndex"
            (selectedTabChange)="onTabChange($event)">
            <mat-tab label="{{'Language.JournalEntryText' | translate}}">
                <!-- <h2 class="heading8">Journal Entry Detail</h2> -->
                <div class="entry-forms">
                    <div class="row">
                        <div class="col-md-6 pe-6">
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="f-label"><span class="required">*</span>{{'Language.BranchNameText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline" >
                                        <input type="text" matInput name="bplName" readonly
                                            (click)="onOpenDropDown(1,0)"
                                            [(ngModel)]="this.getEntryFormDataSource.bplName"
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable"
                                            maxlength="254">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                        (click)="onOpenDropDown(1,0)" [class.disabled-icon]="getFormDisable">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.SeriesText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">

                                        <input type="text" placeholder="Search Series Name" matInput
                                            [formControl]="myControlSeries" [matAutocomplete]="auto"
                                            [(ngModel)]="this.getEntryFormDataSource.seriesName"
                                            (input)="btnEvent($event)" [readonly]="this.getFormDisable"
                                            [ngStyle]="{'color':this.getFormDisable==true?'#1212127a':'black'}">
                                        <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let option of filteredOptionsSeries | async"
                                                [value]="option.name"
                                                (onSelectionChange)="OnOptionSelectedSeries(option)">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-autocomplete>

                                        <!-- <input type="text" matInput readonly>
                                    <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"> -->
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.NumberText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="number" matInput name="number"
                                            [(ngModel)]="this.getEntryFormDataSource.number"
                                            (ngModelChange)="btnEvent($event)" disabled>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label"><span class="required">*</span>{{'Language.PostingDateText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input matInput [matDatepicker]="picker" name="referenceDate"
                                            [(ngModel)]="this.getEntryFormDataSource.referenceDate" 
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label"><span class="required">*</span>{{'Language.DueDateText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input matInput [matDatepicker]="picker1" name="dueDate"
                                            [(ngModel)]="this.getEntryFormDataSource.dueDate" 
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label"><span class="required">*</span>{{'Language.DocumentDateText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input matInput [matDatepicker]="picker2" name="taxDate"
                                            [(ngModel)]="this.getEntryFormDataSource.taxDate" 
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.LocationText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline"    >
                                        <input type="text" matInput readonly name="location" readonly
                                         (click)="onOpenDropDown(3,0)"
                                            [(ngModel)]="this.getEntryFormDataSource.locationName"
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable"
                                            maxlength="254">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2" 
                                        (click)="onOpenDropDown(3,0)" [class.disabled-icon]="getFormDisable">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-12">
                                    <label class="f-label">{{'Language.RemarksText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <textarea type="text" rows="2" matInput
                                            [(ngModel)]="this.getEntryFormDataSource.memo"
                                            (ngModelChange)="btnEvent($event)"
                                            placeholder="Write your remarks"></textarea>
                                        <!-- <mat-hint>Maximum characters limit: XXX</mat-hint> -->
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 pe-6">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.OriginText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="transtype"
                                            [(ngModel)]="this.getEntryFormDataSource.transType"
                                            (ngModelChange)="btnEvent($event)" disabled>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.OriginNoText' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="baseref"
                                            [(ngModel)]="this.getEntryFormDataSource.baseReference"
                                            (ngModelChange)="btnEvent($event)" disabled>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.TransactionNumber' | translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="number" matInput name="transid"
                                            [(ngModel)]="this.getEntryFormDataSource.jdtNum"
                                            (ngModelChange)="btnEvent($event)" disabled>
                                    </mat-form-field>
                                </div>
                                <!-- <div class="col-md-6">
                                    <label class="f-label">Project Name</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput readonly name="projectcode" readonly
                                            (click)="onOpenDropDown(6,0)"
                                            [(ngModel)]="this.getEntryFormDataSource.projectCode"
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable"
                                            maxlength="254">
                                        <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                    </mat-form-field>
                                </div> -->
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.Reference1Text'| translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="reference1"
                                            [(ngModel)]="this.getEntryFormDataSource.reference"
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.Reference2Text'| translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="reference2"
                                            [(ngModel)]="this.getEntryFormDataSource.reference2"
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <label class="f-label">{{'Language.Reference3Text'| translate}}</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput name="reference3"
                                            [(ngModel)]="this.getEntryFormDataSource.reference3"
                                            (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </mat-card-content>
        </mat-card> -->
            </mat-tab>
            <!-- <mat-card class="my-4"> -->
            <mat-tab label="Detail">
                <!-- <div class="ip-section"> -->
                <!-- <mat-card-content> -->
                    <div class="entry-forms">
                        <div class="row">
                            <!-- <div class="col-md-6">
                            <h2 class="heading8">Detail</h2>
                        </div> -->
                            <!-- <div class="col-md-6 text-end fs-9 mt-1">
                                Customize Column
                                <span class="ms-3 customize-column">
                                    <i-feather class="t-icon" name="layers"></i-feather>
                                </span>
                            </div> -->
                        </div>
                    </div>
                    <div class="entry-forms clearfix">
                        <div class="tabledesign">
                            <table mat-table [dataSource]="this.getEntryFormDataSource.documentLines">
                                <ng-container matColumnDef="account_code">
                                    <th mat-header-cell *matHeaderCellDef><span class="required">*</span>Account Code
                                    </th>
                                    <td mat-cell *matCellDef="let row;let index= index;">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline"  >
                                                <input type="text" matInput name="{{row.accountCode}}"
                                                    [(ngModel)]="row.accountCode" value="{{row.accountCode}}"
                                                    (click)="onOpenDropDown('chooseAccountType',index)" readonly="true"
                                                    (ngModelChange)="btnEvent($event)"  (click)="onOpenDropDown('chooseAccountType',index)" [disabled]="this.getFormDisable">
                                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                                  (click)="onOpenDropDown('chooseAccountType',index)" [class.disabled-icon]="getFormDisable">
                                            </mat-form-field>

                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="account_name" style="min-width: 250px;">
                                    <th mat-header-cell *matHeaderCellDef><span class="required">*</span>Account Name
                                    </th>
                                    <td mat-cell *matCellDef="let row;let index= index;" style="min-width: 250px;">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1" appearance="outline"  >
                                                <input type="text" matInput name="{{row.accountName}}"
                                                    [(ngModel)]="row.accountName" value="{{row.accountName}}" readonly="true"
                                                   matTooltip="{{row.accountName}}"  (click)="onOpenDropDown('accounts',index)"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                                <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2"
                                                  (click)="onOpenDropDown('accounts',index)" [class.disabled-icon]="getFormDisable">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="control_account">
                                    <th mat-header-cell *matHeaderCellDef>Control Account</th>
                                    <td mat-cell *matCellDef="let row">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline">
                                                <input type="text" readonly matInput name="{{row.controlAccount}}"
                                                    [(ngModel)]="row.controlAccount" value="{{row.controlAccount}}"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                            </mat-form-field>
                                        </div>
                                    </td>faccount
                                </ng-container>

                                <!-- Debit Column -->
                                <ng-container matColumnDef="debit" stickyEnd>
                                    <th mat-header-cell *matHeaderCellDef><span class="required">*</span>Debit</th>
                                    <td mat-cell *matCellDef="let row">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline">
                                                <input type="number" matInput name="{{row.debit}}"
                                                    [(ngModel)]="row.debit" value="{{row.debit}}"  (input)="calculateTotal()"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>

                                <!-- Credit Column -->
                                <ng-container matColumnDef="credit" stickyEnd>
                                    <th mat-header-cell *matHeaderCellDef><span class="required">*</span>Credit</th>
                                    <td mat-cell *matCellDef="let row">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline">
                                                <input type="number" matInput name="{{row.credit}}"
                                                    [(ngModel)]="row.credit" value="{{row.credit}}"   (input)="calculateTotal()"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="location">
                                    <th mat-header-cell *matHeaderCellDef>Location</th>
                                    <td mat-cell *matCellDef="let row">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline">
                                                <input type="text" readonly matInput
                                                    name="{{this.getEntryFormDataSource.locationName}}"
                                                    [(ngModel)]="this.getEntryFormDataSource.locationName"
                                                    value="{{this.getEntryFormDataSource.locationName}}"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="branch_name">
                                    <th mat-header-cell *matHeaderCellDef>Branch Name</th>
                                    <td mat-cell *matCellDef="let row">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline">
                                                <input type="text" readonly matInput name="{{row.bplName}}"
                                                    [(ngModel)]="row.bplName" value="{{row.bplName}}"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="rowNote">
                                    <th mat-header-cell *matHeaderCellDef>Row Note</th>
                                    <td mat-cell *matCellDef="let row">
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline">
                                                <input type="text" matInput name="{{row.lineMemo}}"
                                                    [(ngModel)]="row.lineMemo" value="{{row.lineMemo}}"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable"
                                                    matTooltip="{{row.lineMemo}}" >
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="project">
                                    <th mat-header-cell *matHeaderCellDef hidden>Project Name</th>
                                    <td mat-cell *matCellDef="let row" hidden>
                                        <div class="pt-1">
                                            <mat-form-field class="field-bottom-0 mb-1 w-160" appearance="outline">
                                                <input type="text" readonly matInput
                                                    name="{{this.getEntryFormDataSource.projectCode}}"
                                                    [(ngModel)]="this.getEntryFormDataSource.projectCode"
                                                    value="{{this.getEntryFormDataSource.projectCode}}"
                                                    (ngModelChange)="btnEvent($event)" [disabled]="this.getFormDisable">
                                            </mat-form-field>
                                        </div>
                                    </td>
                                </ng-container>
                                <!-- Credit Column -->
                                <ng-container matColumnDef="action" stickyEnd >

                                    <th mat-header-cell  *matHeaderCellDef class="text-center">
                                        {{'Language.ActionText' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let row;let i=index" class="text-center" >
                                        <i-feather class="t-icon popinter pointer" name="trash-2"
                                            (click)="deleteRow(i)" 
                                            [ngClass]="{'disabled': this.getFormMode}"> </i-feather>
                                    </td>
                                    
                                </ng-container> 

                                <tr mat-header-row *matHeaderRowDef="this.displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: this.displayedColumns;"></tr>
                            </table>
                        </div>
                        <div class="col-md-12 mt-3" *ngIf="this.getFormMode==0">
                            <button mat-stroked-button color="primary" (click)="addRow()">{{'Language.AddNewItemText' |
                                translate }} </button>
                        </div>
                        <div class="tableTotal mt-3">
                            <div class="d-flex justify-content-end align-items-end">
                                <div class="">
                                    <label class="f-label mt-3">Total</label>
                                </div>
                                <div class="">
                                    <label class="f-label w-156">Debit</label>
                                    <div class="w-156">
                                        <mat-form-field class="field-bottom-0 mb-2 full-width" appearance="outline">
                                            <input type="text" matInput  disabled
                                            [value]="this.debittotal">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="">
                                    <label class="f-label w-156">Credit</label>
                                    <div class="w-156">
                                        <mat-form-field class="field-bottom-0 mb-2 full-width" appearance="outline">
                                            <input type="text" matInput  disabled
                                            [value]="this.credittotal">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end">
                                <div class="">
                                    <label class="f-label mt-3">Difference</label>
                                </div>

                                <div class="">
                                    <div class="w-156">
                                        <mat-form-field class="field-bottom-0 mb-2 full-width" appearance="outline">
                                            <input type="text" matInput disabled
                                            [value]="this.debitdiff">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="">
                                    <div class="w-156">
                                        <mat-form-field class="field-bottom-0 mb-2 full-width" appearance="outline">
                                            <input type="text" matInput disabled
                                            [value]="this.creditdiff">
                                        </mat-form-field>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                <!-- </mat-card-content> -->
                <!-- </div> -->
                <!-- </mat-card> -->
            </mat-tab>
            <!-- ============ ATTACHMENT ============ -->
            <!-- <mat-card class="my-4">
            <mat-card-content> -->
            <mat-tab label="{{'Language.AttachmentsText' | translate
            }}">
                <div class="row">
                    <div class="col-6">
                        <div class="entry-forms">
                            <div class="col-md-12 mt-3">
                                <label class="f-label full-width">{{'Language.AttachmentsText' | translate
                                  }}</label>
                                <button mat-raised-button class="uploadbtn" color="primary" (click)="input.click()">
                                    <i-feather class="t-icon" name="upload"> </i-feather>
                                    {{'Language.ChooseFilesText' | translate }}
                                </button>
                                <input type="file" class="file-upload d-none" #input (change)="onSelectedFiles($event)" multiple>
                                <span class="field-hint d-block">{{'Language.Youcanuploadamaximumof10files,5MBeachText'
                                  | translate }}</span>
                            </div>
                            <div class="col-md-12 mt-4">
                                <div class="carddesign">
                                    <div class="row px-3" *ngIf="this.getEntryFormDataSource.Attachments2_Lines.length > 0">
                                        <label class="col-md-2 f-label">{{'Language.ThumbnailText' | translate
                                            }}</label>
                                        <label class="col-md-5 f-label">{{'Language.FileNameText' | translate
                                            }}</label>
                                        <label class="col-md-2 f-label">{{'Language.FileTypeText' | translate
                                            }}</label>
                                        <label class="col-md-1 f-label">View</label>    
                                        <label class="col-md-2 f-label">{{'Language.DeleteText' | translate
                                        }}</label>
                                    </div>
                                    <mat-card class="add-detail-files mb-2"
                                        *ngFor="let item of this.getEntryFormDataSource.Attachments2_Lines;let i = index">
                                        <mat-card-content class="py-2">
                                            <div class="row">
                                                <div class="col-md-2">
                                                    <i-feather class="" name="image"></i-feather>
                                                </div>
                                                <div class="col-md-5">{{item.FileName}}</div>
                                                <div class="col-md-2">{{item.FileExtension}}</div>
                                                <div class="col-md-1">
                                                    <mat-icon class="pointer" [ngClass]="{'disabled': !item.AbsoluteEntry}" 
                                                    (click)="viewImage(item.AbsoluteEntry)">remove_red_eye</mat-icon>
                                                </div>
                                                <div class="col-md-2">
                                                    <i-feather class="t-icon pointer" name="trash-2"
                                                        (click)="onAttachmentDelete(i)"></i-feather>
                                                </div>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>
        
                            <div class="col-md-12 mt-3">
                                <ng-container *ngIf="this.selectedFile.length > 0">
                                    <div class="text-end">
                                        <button mat-raised-button class="uploadbtn" color="primary" (click)="onUpload()">
                                            <i-feather class="t-icon" name="upload"> </i-feather>
                                            {{'Language.UploadFilesText' | translate }}
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </mat-card-content>
        </mat-card> -->
            </mat-tab>
        </mat-tab-group>
    </div>
    <!-- <div class="mt-2 footer">
        <div class="row">
            <div class="col-md-12">
                <button #buttonSave mat-raised-button color="primary">Save</button>
                <button class="me-2" #buttonCancel mat-raised-button>Cancel</button>
            </div>
        </div>
    </div> -->
    <div class=" mt-2 footer">
        <div class="d-flex">
            <div class="me-auto">
                <button #buttonSave mat-raised-button color="primary" (click)="onSave($event)"
                    *ngIf="selectedTabIndex == 2">
                    {{ btnText | translate}}
                </button>
                <button class="me-2" #buttonCancel mat-raised-button (click)="onClickOfGenericCancelButton($event)">
                    {{'Language.CancelText' | translate}}
                </button>
            </div>
            <div class="">
                <button mat-raised-button color="primary" *ngIf="selectedTabIndex != 0" (click)="navigateTab(-1)">
                    <i-feather class="t-icon" name="chevron-left"> </i-feather>
                    {{'Language.PreviousText' | translate}}
                </button>
                <button mat-raised-button color="primary" class="ms-2" *ngIf="selectedTabIndex != 2"
                    (click)="navigateTab(1)">
                    {{'Language.NextText' | translate}}<i-feather class="t-icon" name="chevron-right">
                    </i-feather>
                </button>
            </div>
        </div>
    </div>
</div>